import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://construction.itpbn.com/backend",
});

export default axiosInstance;
